/* eslint-disable max-lines */
import {
    SpuTimeSaleStockVo,
    TimeSaleStock,
    PlatformCategoryPropTbUpdateCategoryParam,
    PlatformCategoryPropWxChannelCategoryProp,
    PlatformCategoryPropWxStoreCategoryProp,
    MyselfGoodsListQueryVo,
    MyselfGoodsListResultVo,
    RemoveAndProhibitSellParam,
    ManageGoodsListQueryVo2,
    AllRemoveAndProhibitSellParam,
    UpdatePrivateStatus,
    UpdateDistributionResult,
    BuyerSupplierGoodsQueryForMall1,
    GoodsUpdateCategoryParams,
    GoodsUpdatePriceParams,
    ExcelTipsInfo,
    GoodsUpdatePriceParamsForSku,
    GoodsUpdateDistributorPriceParam,
    GoodsUpdateDistributorPriceParamForSku,
    GoodsUpdateOfflineSupplierParams,
    QueryCategoryGroupIdUsingGetParams,
    GoodsBatchUpdateParams,
    ConfirmBatchUpdateGoodsPriceUsingGetParams,
    GetBatchUpdateGoodsProcessUsingGet1Params,
    UpdateGoodsStatus,
    GetBatchUpdateGoodsProcessUsingGetParams,
    UpdateGoodsPriceStatus,
    BatchUpdateGoodsPriceParam,
    ExcelImportVo,
    ImportExcelTipsInfoUsingGetParams,
    QueryExcelTaskUsingGetParams,
    ExcelImportStatus,
    GoodsUpdateStockParams,
    SupplierSpuNumVo,
    GoodsUpdateStatusParams,
    UpdateStatusResult,
    PlatformCategoryPropAlibabaCategoryProp,
    PlatformCategoryPropDouYinCategoryProp,
    PlatformCategoryPropJdCategoryProp,
    PlatformCategoryPropXiaohsCategoryProp,
    PlatformCategoryPropKuaishouCategoryProp,
    PlatformCategoryPropPddCategoryPropUpdateVo,
    PlatformCategoryPropVipCategoryProp,
    PlatformCategoryPropYouZanCategoryProp,
    GetShelvesShopListUsingGetParams,
    SimpleShopVo,
    GetPlatformGroupListUsingGetParams,
    ShelvesShopPlatformGroupListVo,
    GoUserCategoryVo,
    ListUserCategoryByCoIdUsingGetParams,
    GoodsDistributionStatusCheck,
    ImportedShopInfo,
    QueryBindShopUsingGetParams,
    ErpGoodsQueryParam,
    ErpGoodsInfoVo,
    GetCacheSpuIdUsingGetParams,
    CoIdAndSpuId,
    ShelvesStatistics,
    QueryOnlineSkuVo,
    OnlineItemSkuCount,
    QuerySkuStockParam,
    QuerySkuStockResult,
    ShopSkuCountVo,
    ManageGoodsListQueryVo,
    ManageGoodsListResultVo,
    UpdateSkuErpLabel,
    SingleSkuUpdateLabel,
    ErpLabelLibraryParam,
    UpdateErpLabelResult,
    IdNameVo,
    UpdateSpuErpLabel,
    QueryUpdateLabelProcessUsingGetParams,
    DistributionGoodsListQueryVo,
    DistributionGoodsListResultVo,
    DistributionSkuQueryVo,
    DistributionSkuResult,
    SkuPriceResultVo,
    UpdateAllRapidlySpuVo,
    BatchUpdateGoodsNameParam,
    BatchUpdateGoodsNameResult,
    ShelvesGoodsVo,
    SupplierGoodsFreightV2Result,
    QueryFreightParam,
    RapidlySkuQueryVo,
    RapidlySkuResult,
    RapidlyErpInfo,
    UpdateWeightVo,
    CheckCanUpdateUsingGetParams,
    UpdateCostPriceVo,
    QuerySkuByIdUsingGetParams,
    GylGoodsItemSku,
    UpdateStockParamForSku,
    ManageGoodsListQueryVo3,
    UpdateStockVo,
    PreViewUpdateItemNameParam,
    PreViewItemNameVo,
    UpdateItemNameVo,
    UpdateGoodsStatusVo,
    ManualUpdateShopItemParam,
    QueryLogDetailVo,
    ModifyLogDetailListVo,
    GetModifyLogDetailContentUsingGetParams,
    ModifyLogDetailContentVo,
    QueryExcelTitleUsingGetParams,
    CustomExcelResult,
    CustomExcelImportVo,
    BatchUpdateRangePriceResultVo,
    BatchUpdateRangePriceParam,
    QueryTaskUsingGet3Params,
    RedisProgressInfo,
    ModifyBrandParam,
    SupplierChangePriceNum,
    QuerySupplierPurchasePriceChangeSkuIdListUsingGetParams,
    QuerySupplierPurchasePriceChangeSpuIdListUsingGetParams,
    QueryBasicGoodsDataStatisticsUsingGetParams,
    BasicDataStatistics,
    GoodsQtyConfigResult,
    PreViewUpdateItemMainImageParam,
    PreViewItemMainImageVo,
    UpdateItemMainImageVo,
    DouYinCreateSpuParam,
    QuerySpuRuleUsingGetParams,
    DouYinSpuRule,
    ShopSpuQueryVoV2,
    ShopSpuDetailVo,
    GoodsShopSkuQueryVo,
    ShopSkuDetailVo,
    DrpShopSkuQueryVo,
    ErpShopSkuQueryVo,
    ShopSpuQueryParam,
    SkuAndPriceQueryParam,
    GoodsSkuAndPriceVo,
    SkuAndPriceQueryForSkuParam,
    GoodsModifyPriceParam,
    GoodsModifyPriceParamForSku,
    OnlineItemCheckVo,
    OnlineItemInfoVo,
    DeleteShopItemParam,
    ShopManageSkuItemCodeQueryVo,
    ShopDetailParamVo,
    SimpleShopSpuVo,
    UpdateItemCodeVo,
    CanUpdateShopUsingGetParams,
    CanUpdateResultVo,
    CheckValidSpuSatisfiedVo,
    UpdateAssignShopVo,
    UpdateStoreAvailableVo,
    BranchShopModifyLogParam,
    BranchShopModifyLogVo,
    BatchOperateSpuVo,
    CoIdAndSpuVo,
    DraftStatusResultVo,
    DraftStatusSkuParamVo,
    DraftStatusSkuResultVo,
    GoodsOperateLogVo,
    ShelvesLogDetailUsingGetParams,
    GylItemShelvesInfo,
    GoodsImportLogDetailQueryVo,
    GoodsImportLogDetailVo,
    ImportLogUsingGetParams,
    GoodsImportLoad,
    QueryDeletedSkuParam,
    DeletedSkuVo,
    OperateLogVo,
    OnlineItemOperateLogQueryVo,
    GetModifyLogDetailContentUsingGet1Params,
    GoodsImportLogTagQueryVo,
    QueryImportDetailTag,
    LogOperateTypeVo,
    QueryGoodsListUsingGetParams,
    BreakPriceResultVo,
    ExportRePriceParam,
    ImportModifyRegulateVo,
    RegulatePriceModifyParam,
    RegulatePriceModifySkuParam,
    BreakPriceSumVo,
    QueryBreakPriceItemUsingGetParams,
    RpaRelationItemVo,
    ExportBreakPriceItemUsingGetParams,
    QueryStyleCodeListUsingGetParams,
    BatchFreshmanLabelUpdateVo,
    FreshmanUpdateTipVo,
    ShopManageSkuQueryVo,
    TaoBaoShelvesTemplateContent,
    DouyinShelvesTemplateContent,
    PddShelvesTemplateContent,
    KuaishouShelvesTemplateContent,
    JdShelvesTemplateContent,
    QueryFirstOnlineShopGoodsUsingGetParams,
    FirstOnlineShopGoodsResult,
    UpdateLimitShelvesPlatformParam,
    UpdateLimitShelvesPlatformParamAll,
    UpdateLimitShelvesPlatformParamMallAll,
    BatchUpdateRegulatePriceInterceptParam,
    BatchAllUpdateRegulatePriceInterceptParam,
    BatchAllUpdateRegulatePriceInterceptParam1,
    BatchForShelvedParam,
    QueryErpLogParam,
    ShopItemErpLog,
    SpuListAsyncInfo,
    SupplierSyncShopItemVo,
    AsyncLoadMainPicVo,
    ReplaceOnlineMainImageVo,
    ListByCoIdUsingGetParams,
    SimpleUserCatVo,
    QueryGoodsListV2UsingGetParams,
    TurnAbnormalParam,
    QueryLimitPlatformChannelParam,
    QueryLimitPlatformChannelResp,
} from '@servicesTypings/goodsRequest'
import { ListAllSupplierOfflineUsingGetParams, ErpOfflineSupplierVo } from '@servicesTypings/drpRequest'
import {
    QueryShopTotalDTO,
    ShopTotalVo,
    GetShopBranchInfoUsingGetParams,
    ShopBranchInfoVO,
    OfficialUrlUsingGetParams,
} from '@servicesTypings/companyRequest'

import { companyRequest, drpRequest, goodsRequest, openGoodsRequest, goodsBasicRequest } from '@/utils/request'
import { captureException } from '@/utils/track'

import { GoodsOperateLogQueryVo, DrpOperateLogVo, GoDrpGoodsOperateLogDetail } from '@servicesTypings/goodsRequestV3'

/**
 * 自主商品【批量修改淘特类目】
 */
/**
 * 批量修改淘特类目
 */
export function upsertTaoBaoLiteProp(data: PlatformCategoryPropTbUpdateCategoryParam): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertTaoBaoLiteProp', { data })
}

/**
 * 自主商品【批量修改淘宝类目】
 */
/**
 * 批量修改淘宝类目
 */
export function updateTaoBaoProp(data: PlatformCategoryPropTbUpdateCategoryParam): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertTaoBaoProp', { data })
}

/**
 * 自主商品【批量修改微信小店类目】
 */
/**
 * 批量修改微信小店类目
 */
export function updateWxChannelProp(data: PlatformCategoryPropWxChannelCategoryProp): API.Res<null> {
    return goodsRequest.post('/platformCategoryProp/upsertWxChannelProp', { data })
}

/**
 * 自主商品【批量修改微信小商店类目】
 */
/**
 * 批量修改微信小商店类目
 */
export function updateWxStoreProp(data: PlatformCategoryPropWxStoreCategoryProp): API.Res<null> {
    return goodsRequest.post('/platformCategoryProp/upsertWxStoreProp', { data })
}

/**
 * 自主商品商品列表
 */
/**
 * 查询合作商品管理列表
 */
export function queryTable(data: MyselfGoodsListQueryVo): API.Res<MyselfGoodsListResultVo[]> {
    return goodsRequest.post('/supplier/goods/list', { data })
}

/**
 * 自主商品商品【删除商品】
 */
/**
 * 删除合作商品管理
 */
export function remove(data: string[]): API.Res<string> {
    return goodsRequest.post('/supplier/goods/remove', { data })
}

/**
 * 删除并且分销禁售
 */
/**
 * 删除并且分销禁售
 */
export function removeAndProhibitSell(data: RemoveAndProhibitSellParam): API.Res<string> {
    return goodsRequest.post('/supplier/goods/removeAndProhibitSellV2', { data })
}

/**
 * 自主商品商品【批量全页删除商品】
 */
/**
 * 全部页全选删除
 */
export function removeForFullPage(data: ManageGoodsListQueryVo2): API.Res<string> {
    return goodsRequest.post('/supplier/goods/allPagesSelectAllDelete', { data })
}

/**
 * 自主商品商品【批量全页删除商品】
 */
/**
 * 全部页全选删除
 */
export function removeForFullPageV2(data: AllRemoveAndProhibitSellParam): API.Res<string> {
    return goodsRequest.post('/supplier/goods/allPagesSelectAllDeleteV2', { data })
}

/**
 * 自主商品商品列表
 */
/**
 * 批量设置商品公开私密状态
 */
export function updatePrivateStatus(data: UpdatePrivateStatus): API.Res<UpdateDistributionResult> {
    return goodsRequest.post('/supplier/goods/updatePrivateStatus', { data })
}

// 根据条件更新商品分销状态(全部页全选)
/**
 * 根据条件更新商品分销状态(全部页全选)
 */
export function updatePrivateStatusByCondition(data: BuyerSupplierGoodsQueryForMall1): API.Res<string> {
    return goodsRequest.post('/supplier/goods/updatePrivateStatusByCondition', { data })
}

/**
 * 自主商品【批量更新类目】
 */
/**
 * 批量修改类目
 */
export function updateCategory(data: GoodsUpdateCategoryParams): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateCategorys', { data })
}

/**
 * 自主商品【批量更新基本售价】
 */
/**
 * 批量修改基本售价
 */
export function updateBasePrices(data: GoodsUpdatePriceParams): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateBasePrices', { data })
}

/**
 * 自主商品【批量更新零售价检测】
 */
/**
 * 查询批量修改基本售价提示说明
 */
export function queryUpdateBasePricesTask(data: GoodsUpdatePriceParams): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryUpdateBasePricesTask', { data })
}

/**
 * 自主商品【批量更新基本售价：按成本价】（款）
 */
/**
 * 按成本价改价查询批量修改基本售价提示说明
 */
export function queryUpdateBasePriceByCostPriceApi(data: GoodsUpdatePriceParams): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryUpdateBasePriceByCostPrice', { data })
}

/**
 * 自主商品【批量更新基本售价：按成本价】（sku）
 */
/**
 * 按成本价改价查询批量修改基本售价提示说明
 */
export function queryUpdateBasePriceByCostPriceForSkuApi(data: GoodsUpdatePriceParamsForSku): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryUpdateBasePriceByCostPriceForSku', { data })
}

/**
 * 批量修改重量
 */
/**
 * swagger找不到此接口
 */
export function updateWeightforSku(data) {
    return goodsRequest.post('/supplier/goods/updateWeightforSku', {
        data,
    })
}

/**
 * 自主商品【按采购价批量修改基本售价提示说明】
 */
/**
 * 按采购价改价查询批量修改基本售价提示说明
 */
export function queryUpdateBasePriceByPurchase(data: GoodsUpdatePriceParams): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryUpdateBasePriceByPurchase', { data })
}

/**
 * 自主商品【批量更新零售价】
 */
/**
 * 批量修改零售价
 */
export function updateSalePrices(data: GoodsUpdatePriceParams): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateSalePrices', { data })
}

/**
 * 供销商品管理【批量更新供货价】
 */
/**
 * 批量修改spu1-5级供货价(异步)
 */
export function updateDistributorPrice(data: GoodsUpdateDistributorPriceParam): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateSpuDistributorPriceWithAsyn', { data })
}

/**
 * 供销商品管理【批量更新供货价:按成本价】
 */
/**
 * 按成本价批量修改spu1-5级供货价(异步)
 */
export function updateDistributorPriceByCostPrice(data: GoodsUpdateDistributorPriceParam): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateSpuDistributorPriceByCostPriceWithAsyn', { data })
}

/**
 * 供销商品管理Sku级【批量更新供货价】
 */
/**
 * 批量修改sku1-5级供货价(异步)
 */
export function updateDistributorPriceSku(data: GoodsUpdateDistributorPriceParamForSku): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateSkuDistributorPriceWithAsyn', { data })
}

/**
 * 供销商品管理Sku级【批量更新供货价:按成本价】
 */
/**
 * 按成本价批量修改sku1-5级供货价(异步)
 */
export function updateDistributorPriceForSkuByCostPrice(data: GoodsUpdateDistributorPriceParamForSku): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateSkuDistributorPriceByCostPriceWithAsyn', { data })
}

/**
 * 自主商品【查询所属供应商列表-下拉框】
 */
/**
 * 所属供应商列表-下拉框
 */
export function querySupplierOffline(params: ListAllSupplierOfflineUsingGetParams): API.Res<ErpOfflineSupplierVo[]> {
    return drpRequest.get('/supplier/offline/listAllSupplierOffline', { params })
}

/**
 * 自主商品【批量更新供应商】
 */
/**
 * 批量修改线下自主供应商
 */
export function updateOfflineSupplier(data: GoodsUpdateOfflineSupplierParams): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateOfflineSuppliers', { data })
}

/**
 * 自主商品商品列表查询类目列表
 */
/**
 * 查询供应链一级类目组集合(不带淘宝一级类目)
 */
export function queryCategoryGroupId(params: QueryCategoryGroupIdUsingGetParams): API.Res<object> {
    return goodsBasicRequest.get('/goCategory/queryCategoryGroupId', { params })
}

// 供销商品管理
/**
 * 下载导入更新价格模板
 */
export function downloadUpdatePriceTpl(): API.Res<string> {
    return goodsRequest.get('/myself/distribution/goods/downloadUpdatePriceTpl')
}

/**
 * 导入更新商品【异步方式】【上传商品Excel 传阿里云文件地址给服务端 第1步】
 */
/**
 * 批量修改商品
 */
export function beforeBatchUpdateGoods(data: GoodsBatchUpdateParams): API.Res<string> {
    return goodsRequest.post('/supplier/goods/batchUpdateGoods', { data })
}

/**
 * 供销商品管理-导入更新商品【异步方式】【上传商品Excel 传阿里云文件地址给服务端 第1步】
 */
/**
 * 确认批量更新商品价格
 */
export function confirmBatchUpdateGoodsPrice(params: ConfirmBatchUpdateGoodsPriceUsingGetParams): API.Res<string> {
    return goodsRequest.get('/myself/distribution/goods/confirmBatchUpdateGoodsPrice', { params })
}

/**
 * 导入更新商品【异步方式】【获取进度条 第2步】
 */
/**
 * 获取进度条
 */
export function getBatchUpdateGoodsProcess(
    params: GetBatchUpdateGoodsProcessUsingGet1Params,
): API.Res<UpdateGoodsStatus> {
    return goodsRequest.get('/supplier/goods/getBatchUpdateGoodsProcess', { params })
}

/**
 * 供销商品管理-导入更新商品【异步方式】【获取进度条 第2步】
 */
/**
 * 获取进度条
 */
export function getBatchUpdateGoodsPriceProcess(
    params: GetBatchUpdateGoodsProcessUsingGetParams,
): API.Res<UpdateGoodsPriceStatus> {
    return goodsRequest.get('/myself/distribution/goods/getBatchUpdateGoodsPriceProcess', { params })
}

/**
 * 导入更新商品【上传商品Excel】
 */
/**
 * 确认批量更新商品
 */
export function importBatchUpdateGoods(data: GoodsBatchUpdateParams): API.Res<string> {
    return goodsRequest.post('/supplier/goods/importBatchUpdateGoods', { data })
}

/**
 * 供销商品管理-导入更新商品【上传商品Excel】
 */
/**
 * 批量更新商品价格
 */
export function batchUpdateGoodsPrice(data: BatchUpdateGoodsPriceParam): API.Res<string> {
    return goodsRequest.post('/myself/distribution/goods/batchUpdateGoodsPrice', { data })
}

/**
 * 批量导入商品【标准 Excel导入商品 - 下载模板】
 */
/**
 * 下载商家导入商品EXCEL模板
 */
export function downExcellIntoGoodsTpl(): API.Res<string> {
    return goodsRequest.get('/supplier/goods/downloadTpl')
}

/**
 * 批量导入商品-分销小站【标准 Excel导入商品 - 下载模板】
 */
/**
 * 下载商家分销小站导入商品EXCEL模板
 */
export function downExcellIntoDrpGoodsTpl(): API.Res<string> {
    return goodsRequest.get('/supplier/goods/downloadDrpTpl')
}

/**
 * 通过EXCEL批量提报ERP商品
 */
export function importExcelErpGoods(data: ExcelImportVo): API.Res<string> {
    return goodsRequest.post('/supplier/goods/importExcelErpGoods', { data })
}

/**
 * 上传Excel获取任务id和新增ERP的商品编码
 */
export function importExcelTipsInfo(params: ImportExcelTipsInfoUsingGetParams): API.Res<ExcelTipsInfo> {
    return goodsRequest.get('/supplier/goods/importExcelTipsInfo', { params })
}

/**
 * 批量导入商品【标准和ERP Excel导入商品】 (统一查询导入进度)
 */
/**
 * 查询Excel导入进度
 */
export function queryExcelTask(params: QueryExcelTaskUsingGetParams): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/supplier/goods/queryExcelTask', { params })
}

/**
 * swagger找不到此接口
 */
export function excelUpdateTipsInfo(params) {
    return goodsRequest.get('/myself/rapidly/goods/excelUpdateTipsInfo', {
        params,
    })
}

/**
 * swagger找不到此接口
 */
export function excelUpdate(data) {
    return goodsRequest.post('/myself/rapidly/goods/excelUpdate', {
        data,
    })
}

/**
 * 自主商品批量更新图片【检测】
 */
/**
 * 校验spu款式编码或者规格是否存在（用于批量导入图片功能校验）
 */
export function testStyleCodeOrColour(data: object): API.Res<Record<string, object>> {
    return goodsRequest.post('/supplier/goods/testStyleCodeOrColour', { data })
}

/**
 * 自主商品批量更新图片【提交上传更新】
 */
/**
 * 批量上传图片
 */
export function uploadImageList(data: object): API.Res<object> {
    return goodsRequest.post('/supplier/goods/uploadImageList', { data })
}

// 批量修改库存
/**
 * 批量修改库存
 */
export function updateStock(data: GoodsUpdateStockParams): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateStocks', { data })
}

// 查询待完善数量
/**
 * 获取供应商商品数量统计
 */
export function fetchDefectiveNumApi(): API.Res<SupplierSpuNumVo> {
    return goodsRequest.get('/supplier/goods/numbers')
}

// 更新分销状态
/**
 * 批量修改商品状态
 */
export function updateGoodsStatus(data: GoodsUpdateStatusParams): API.Res<UpdateStatusResult> {
    return goodsRequest.post('/supplier/goods/updateStatuss', { data })
}

// 添加到我的盘货表并修改商品状态
/**
 * swagger找不到此接口
 */
export function addToActivityGroupAndChangeSpuStatusApi(data) {
    return goodsRequest.post('/gyl/buyerActivityGroup/addToActivityGroupAndChangeSpuStatus', {
        data,
    })
}

// 查询商品不可见分销商
/**
 * swagger找不到此接口
 */
export function queryItemInvisiblePartner(params) {
    return goodsRequest.get('/itemInvisiblePartner/list', {
        params,
    })
}

// 保存不可见分销商列表
/**
 * swagger找不到此接口
 */
export function saveItemInvisiblePartner(data) {
    return goodsRequest.post('/itemInvisiblePartner/save', {
        data,
    })
}

/**
 * 自主商品【批量更新1688类目属性】
 */
/**
 * 批量更新1688类目
 */
export function updateAlibabaProp(data: PlatformCategoryPropAlibabaCategoryProp): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertAlibabaProp', { data })
}

/**
 * 自主商品【批量更新抖音类目属性】
 */
/**
 * 更新抖音类目属性
 */
export function updateDouyinProp(data: PlatformCategoryPropDouYinCategoryProp): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertDouYinProp', { data })
}

/**
 * 自主商品【批量更新京东类目】
 */
/**
 * 批量更新京东类目
 */
export function updateJdProp(data: PlatformCategoryPropJdCategoryProp): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertJdProp', { data })
}

/**
 * 自主商品【批量更新小红书类目】
 */
/**
 * 批量修改小红书类目
 */
export function upsertXiaohsProp(data: PlatformCategoryPropXiaohsCategoryProp): API.Res<null> {
    return goodsRequest.post('/platformCategoryProp/upsertXiaohsProp', { data })
}

/**
 * 自主商品【更新快手类目属性】
 */
/**
 * 更新快手类目属性
 */
export function updateKuaishouProp(data: PlatformCategoryPropKuaishouCategoryProp): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertKuaishouProp', { data })
}

/**
 * 自主商品【更新拼多多类目属性】
 */
/**
 * 更新拼多多类目属性
 */
export function updatePddProp(data: PlatformCategoryPropPddCategoryPropUpdateVo): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertPddProp', { data })
}

/**
 * 自主商品【更新唯品会类目属性】
 */
/**
 * 批量修改唯品会类目
 */
export function upsertVipProp(data: PlatformCategoryPropVipCategoryProp): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertVipProp', { data })
}

/**
 * 自主商品【批量更新有赞类目属性】
 */
/**
 * 更新有赞类目属性
 */
export function updateYouZanProp(data: PlatformCategoryPropYouZanCategoryProp): API.Res<object> {
    return goodsRequest.post('/platformCategoryProp/upsertYouZanProp', { data })
}

/**
 * 自主商品商品列表查询已上架或者未上架店铺列表
 */
/**
 * 铺货店铺列表查询，可筛选已铺货店铺、未铺货店铺
 */
export function getGoShelvesShopList(params: GetShelvesShopListUsingGetParams): API.Res<SimpleShopVo[]> {
    return goodsRequest.get('/shelvesShop/list', { params })
}

/**
 * 渠道侧商家展架铺货状态的店铺列表
 */
/**
 * 铺货店铺按平台分组，可查询已铺货店铺、未铺货店铺
 */
export function getPlatformGroups(params: GetPlatformGroupListUsingGetParams): API.Res<ShelvesShopPlatformGroupListVo> {
    return goodsRequest.get('/shelvesShop/platformGroupList', { params })
}

/**
 * 渠道侧商家展架铺货状态的店铺列表（已分配权限的店铺列表）
 */
/**
 * 可见店铺按平台分组
 */
export function getCanSeeShopGroupList(): API.Res<ShelvesShopPlatformGroupListVo> {
    return goodsRequest.get('/shelvesShop/canSeeShopGroupList')
}

// open 展架
/**
 * 根据供应商ID查询精简类目信息
 */
export function userCategoryListByCoIdOpen(params: ListByCoIdUsingGetParams): API.Res<SimpleUserCatVo[]> {
    return openGoodsRequest.get('/open/userCategory/listByCoId', { params })
}

/**
 * 展架类目查询自定义类目下拉列表 【有商品数量】
 */
/**
 * 供应侧查询自定义类目下拉列表
 */
export function getGoUserCategory(): API.Res<GoUserCategoryVo[]> {
    return goodsRequest.get('/goods/goUserCategory/lisQtyOptions')
}

/**
 * 设置展架类目
 */
/**
 * 根据coId查询精简类目信息
 */
export function getListUserCategoryByCoId(params: ListUserCategoryByCoIdUsingGetParams): API.Res<SimpleUserCatVo[]> {
    return goodsRequest.get('/goods/goUserCategory/listUserCategoryByCoId', { params })
}

/**
 * 批量代发转自营商品
 */
export function distributionTransNormalApi(data, params) {
    // 记录下，防止有地方漏传
    if (!params?.transDistributionNormalType) {
        captureException('参数缺失', {
            anchor: 'distributionTransNormalApi',
            extra: {
                data,
            },
        })
    }

    return goodsRequest.post('/distributor/goods/distributionTransNormalByList', {
        data,
        params,
    })
}

/**
 * 校验选中商品是否全部是代发商品
 */
/**
 * 校验选中商品是否全部为代发商品
 */
export function checkDistributionStatus(data: string[]): API.Res<GoodsDistributionStatusCheck> {
    return goodsRequest.post('/distributor/goods/checkGoodsStatus', { data })
}

/**
 * 获取用户已导入店铺信息
 */
/**
 * 获取用户已导入店铺信息
 */
export function queryImportedShop(): API.Res<ImportedShopInfo[]> {
    return goodsRequest.get('/goods/goGoodsImportSpuDetail/queryImportedShopInfo')
}

/**
 * 获取用户已导入供应商数字
 */
export function queryShopCount() {
    return companyRequest.get('/shop/shopCount')
}

/**
 * 查询商家是否上架过商品
 */
export function querySupplierShelvesItem() {
    return goodsRequest.get('/goods/querySupplierShelvesItem')
}

/**
 * 查询绑定店铺店铺shopId
 */
/**
 * 根据店铺类型获取店铺信息
 */
export function queryBindShopApi(params: QueryBindShopUsingGetParams): API.Res<Record<string, object>> {
    return goodsRequest.get('/shelves/mxStoresInformation/queryBindShop', { params })
}

/**
 * 查询款SPU维度的ERP商品信息（库存、成本价等）
 */
/**
 * 查询款纬度的ERP相关字段信息
 */
export function querySpuErpInfoList(data: ErpGoodsQueryParam): API.Res<ErpGoodsInfoVo[]> {
    return goodsRequest.post('/goodslist/erp/queryErpInfoListForSpu', { data })
}

/**
 * 查询款SKU的ERP商品信息（库存、成本价等）
 */
/**
 * swagger找不到此接口
 */
export function querySpuErpInfoListForSku(data) {
    return goodsRequest.post('/goodslist/erp/queryErpInfoListForSku', {
        data,
    })
}

/**
 * 查询ERP快速铺货临时数据
 */
/**
 * 获取ERP直接上架缓存商品ID
 */
export function queryCacheSpuId(params: GetCacheSpuIdUsingGetParams): API.Res<CoIdAndSpuId> {
    return goodsRequest.get('/erpDirectShelves/getCacheSpuId', { params })
}

/**
 * 查询商家快速铺货节省时间
 */
/**
 * 统计铺货节约时间
 */
export function queryShelvesStatistics(): API.Res<ShelvesStatistics> {
    return goodsRequest.get('/buyer/gylItemShelvesInfo/queryShelvesStatistics')
}

/**
 * 商品管理-关联线上商品【查看线上关联商品】
 */
/**
 * 查看线上关联商品
 */
export function getSupplierPartnerSkuList(data: QueryOnlineSkuVo): API.Res<OnlineItemSkuCount[]> {
    return goodsRequest.post('/goodsManage/shopSku/list', { data })
}

/**
 *
 * 查询自己商品(sku维度)的库存
 */
/**
 * 查询自己商品(sku维度)的库存
 */
export function queryMySelfSkuStock(data: QuerySkuStockParam): API.Res<QuerySkuStockResult[]> {
    return goodsRequest.post('/goodsManage/shopSku/queryMySelfSkuStock', { data })
}

/**
 * 店铺商品资料计数汇总
 */
/**
 * 店铺商品资料计数汇总
 */
export function queryShopSkuCount(data: QueryOnlineSkuVo): API.Res<ShopSkuCountVo> {
    return goodsRequest.post('/goodsManage/shopSku/queryShopSkuCount', { data })
}

/**
 * 纯净版商品商品列表
 */
/**
 * 急速版自己的商品列表
 */
export function queryPureTable(data: ManageGoodsListQueryVo): API.Res<ManageGoodsListResultVo[]> {
    return goodsRequest.post('/myself/rapidly/goods/list', { data })
}

export enum ErpLabelType {
    SYSTEM = 'SYSTEM',
    NORMAL = 'NORMAL',
}

export interface ErpLabel {
    labelType: ErpLabelType
    labelName: string
}

// 商品标签列表
export function queryErpLabelList(params: {}): API.Res<ErpLabel[]> {
    return goodsRequest.get('/erp/item/label/queryErpLabelList', {
        params,
    })
}

/**
 * 商品标签同步到ERP
 */
/**
 * SKU维度修改商品标签提示信息
 */
export function updateBatchErpLabelForSkuTips(data: UpdateSkuErpLabel): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/goodsErpLabel/batchModifyErpLabelForSkuTips', { data })
}

/**
 * 商品标签同步到ERP(style)
 */
/**
 * 单个修改SKU维度商品标签提示信息
 */
export function updateSingleErpLabelForSkuTips(data: SingleSkuUpdateLabel): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/goodsErpLabel/singleModifyErpLabelForSkuTips', { data })
}

/**
 * 商品标签更新
 */
/**
 * 更新ERP标签
 */
export function upsertErpLabelForSku(data: ErpLabelLibraryParam): API.Res<object> {
    return goodsRequest.post('/erp/item/label/upsertErpLabel', { data })
}

/**
 * 批量更新商品标签
 */
/**
 * 批量修改SKU维度商品标签
 */
export function upsertBatchErpLabelForSku(data: UpdateSkuErpLabel): API.Res<UpdateErpLabelResult> {
    return goodsRequest.post('/goodsErpLabel/batchModifyErpLabelForSku', { data })
}

/**
 * 单个更新商品标签
 */
/**
 * 单个修改SKU维度商品标签
 */
export function upsertSingleErpLabelForSku(data: SingleSkuUpdateLabel): API.Res<object> {
    return goodsRequest.post('/goodsErpLabel/singleModifyErpLabelForSku', { data })
}

/**
 * 获取原始选中的商品标签
 */
/**
 * SKU维度同步ERP标签至供应链
 */
export function getSelectedTags(data: IdNameVo): API.Res<string[]> {
    return goodsRequest.post('/goodsErpLabel/syncErpLabelToGylForSku', { data })
}

/**
 * spu 标签修改提示
 * @param {*} post
 */
/**
 * 批量修改款维度商品标签提示信息
 */
export function batchModifyErpLabelForSpuTips(data: UpdateSpuErpLabel): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/goodsErpLabel/batchModifyErpLabelForSpuTips', { data })
}

/**
 * spu 批量修改款维度商品标签
 * @param {*} data
 */
/**
 * 批量修改款维度商品标签
 */
export function batchModifyErpLabelForSpu(data: UpdateSpuErpLabel): API.Res<string> {
    return goodsRequest.post('/goodsErpLabel/batchModifyErpLabelForSpu', { data })
}

/**
 * spu 查询更新ERP标签进度
 * @param {*} params
 */
/**
 * 查询更新ERP标签进度
 */
export function queryUpdateLabelProcess(params: QueryUpdateLabelProcessUsingGetParams): API.Res<UpdateErpLabelResult> {
    return goodsRequest.get('/goodsErpLabel/queryUpdateLabelProcess', { params })
}

/**
 * SPU维度同步ERP标签至供应链
 */
/**
 * SPU维度同步ERP标签至供应链
 */
export function syncErpLabelSpu(data: IdNameVo): API.Res<string[]> {
    return goodsRequest.post('/goodsErpLabel/syncErpLabelToGylForSpu', { data })
}

/**
 * 纯净版商品商品列表
 */
/**
 * 分销商品的商品列表
 */
export function queryDistributeTable(data: DistributionGoodsListQueryVo): API.Res<DistributionGoodsListResultVo[]> {
    return goodsRequest.post('/myself/distribution/goods/list', { data })
}

/**
 * 供销商品管理（sku商品列表）
 */
/**
 * 供销商品SKU列表查询
 */
export function queryDistributionSku(data: DistributionSkuQueryVo): API.Res<DistributionSkuResult[]> {
    return goodsRequest.post('/myself/distribution/goods/sku/list', { data })
}

/**
 * 供销商品管理（sku商品列表）
 */
/**
 * 供销商品SKU列表查询ERP价格
 */
export function queryErpPrice(data: string[]): API.Res<SkuPriceResultVo[]> {
    return goodsRequest.post('/myself/distribution/goods/sku/queryErpPrice', { data })
}

/**
 * 纯净版更新分销状态
 */

/**
 * 设置商品状态为可分销
 */
export function updatePrueGoodsStatus(data: GoodsUpdateStatusParams): API.Res<UpdateDistributionResult> {
    return goodsRequest.post('/myself/rapidly/goods/updateDistribution', { data })
}

/**
 * 全页全选模式下,设置分销状态，
 */

/**
 * 设置满足条件的商品状态为可分销
 */
export function updateGoodsDistributionStatus(data: UpdateAllRapidlySpuVo): API.Res<string> {
    return goodsRequest.post('/myself/rapidly/goods/updateDistributionForCondition', { data })
}

/**
 * 批量更新商品名称
 */
/**
 * 批量更新商品名称
 */
export function updateGoodsNames(data: BatchUpdateGoodsNameParam): API.Res<BatchUpdateGoodsNameResult> {
    return goodsRequest.post('/supplier/goods/updateGoodsNames', { data })
}

/*
 * 查询供销最低物流运费
 * */
/**
 * 获取供销最低物流运费
 */
export function querySupplierMinFreight(data: ShelvesGoodsVo): API.Res<SupplierGoodsFreightV2Result> {
    return goodsRequest.post('/buyer/supplier/querySupplierMinFreightV2', { data })
}

/*
 * 批量查询供销最低物流运费
 * */
/**
 * 批量获取供销最低物流运费
 */
export function querySupplierMinFreightForBatchShelves(
    data: QueryFreightParam[],
): API.Res<SupplierGoodsFreightV2Result[]> {
    return goodsRequest.post('/buyer/supplier/batchQuerySupplierMinFreightV2', { data })
}

/**
 * 供销商品管理：极速版按SKU列表
 */
/**
 * 急速版自己的商品列表
 */
export function queryPureSkuTable(data: RapidlySkuQueryVo): API.Res<RapidlySkuResult[]> {
    return goodsRequest.post('/myself/rapidly/sku/list', { data })
}

/**
 * 供销商品管理：极速版按SKU列表[库存数]
 */
/**
 * 列表根据skuId查询ERP信息, 价格库存
 */
export function queryErpStockPriceBySkuId(data: string[]): API.Res<RapidlyErpInfo[]> {
    return goodsRequest.post('/myself/rapidly/sku/queryErpStockPriceBySkuId', { data })
}

/**
 * 分页查询商品增量包
 */
export function pageListGoodsAdditionalQtyApi(data) {
    return goodsBasicRequest.post('/limit/pageListGoodsAdditionalQty', {
        data,
    })
}
/**
 * 查询生效的商品增量包
 */
export function activeGoodsAdditionalQtyListApi(params) {
    return goodsBasicRequest.get('/limit/activeGoodsAdditionalQtyList', {
        params,
    })
}

/**
 * 校验选中商品是否全部是代发商品
 */
/**
 * 校验选中sku是否全部为代发商品
 */
export function checkDistributionStatusForSku(data: string[]): API.Res<GoodsDistributionStatusCheck> {
    return goodsRequest.post('/distributor/goods/checkGoodsStatusForSku', { data })
}

/**
 * 供应测商品管理【sku】【批量更新零售价检测】
 */
/**
 * 查询批量修改sku基本售价提示说明
 */
export function queryUpdateBasePricesTaskForSku(data: GoodsUpdatePriceParamsForSku): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryUpdateBasePricesTaskForSku', { data })
}

/**
 * 供应测商品管理【按采购价批量修改基本售价提示说明】
 */
/**
 * 按采购价改价查询批量修改sku基本售价提示说明
 */
export function queryUpdateBasePriceByPurchaseForSku(data: GoodsUpdatePriceParamsForSku): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/queryUpdateBasePriceByPurchaseForSku', { data })
}

/**
 * 供应测商品管理【sku批量修改基础价格】
 */
/**
 * 批量修改sku基本售价
 */
export function updateBasePricesForSku(data: GoodsUpdatePriceParamsForSku): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateBasePricesForSku', { data })
}

/**
 * 供应测商品管理【sku批量更新零售价】
 */
/**
 * 批量修改满足条件的商品零售价
 */
export function updateSalePricesForAllPage(data: UpdateAllRapidlySpuVo): API.Res<string> {
    return goodsRequest.post('/myself/rapidly/goods/updateSalePricesForCondition', { data })
}

/**
 * 供应测商品管理【sku批量修改重量】
 */
/**
 * 修改sku重量
 */
export function updateSkuWeightForSku(data: UpdateWeightVo): API.Res<object> {
    return goodsRequest.post('/myself/rapidly/sku/updateSkuWeight', { data })
}

/**
 * 供应测商品管理【sku 查询合作关系】
 */
/**
 * 判断能否更新代发商品sku
 */
export function checkSymbiosis(params: CheckCanUpdateUsingGetParams): API.Res<object> {
    return goodsRequest.get('/myself/distribution/goods/sku/checkCanUpdate', { params })
}

//
/**
 * 供应测商品管理【sku批量修改重量】
 */
/**
 * 修改sku重量提示信息
 */
export function updateSkuWeightTipForSku(data: UpdateWeightVo): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/myself/rapidly/sku/updateWeightTips', { data })
}

/**
 * 供应测商品管理【sku批量修改重量】
 */
/**
 * 修改成本价
 */
export function updateSkuCostPriceForSku(data: UpdateCostPriceVo): API.Res<object> {
    return goodsRequest.post('/myself/rapidly/sku/updateCostPrice', { data })
}

/**
 * 供应测商品管理【sku批量修改重量】
 */
/**
 * 修改成本价提示信息
 */
export function updateSkuCostPriceTipForSku(data: UpdateCostPriceVo): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/myself/rapidly/sku/updateCostPriceTips', { data })
}

/**
 * 供应测商品管理【sku 查询sku信息库存】
 */
/**
 * 根据skuId查询SKU信息
 */
export function querySkuByIdForSku(params: QuerySkuByIdUsingGetParams): API.Res<GylGoodsItemSku> {
    return goodsRequest.get('/myself/rapidly/sku/querySkuById', { params })
}

/**
 * 供应测商品管理【sku批量更新零售价】
 */
/**
 * 批量修改sku零售价
 */
export function updateSalePricesForSku(data: GoodsUpdatePriceParamsForSku): API.Res<object> {
    return goodsRequest.post('/supplier/goods/updateSalePricesForSku', { data })
}

/**
 * 供应测商品管理【sku批量修改库存】
 */
/**
 * 修改sku库存
 */
export function updateStockForSku(data: UpdateStockParamForSku): API.Res<object> {
    return goodsRequest.post('/goods/stock/updateStockForSku', { data })
}

/**
 * 商品管理导出更新商品【导出商品】
 */
/**
 * 批量导出
 */
export function exportImportUpdateGoods(data: string[]): API.Res<string> {
    return goodsRequest.post('/myself/rapidly/goods/exportImportUpdateGoods', { data })
}

/**
 * 商品管理导出更新商品【批量全页导出商品】
 */
/**
 * 全部页全选导出
 */
export function exportImportUpdateGoodsForFullPage(data: ManageGoodsListQueryVo3): API.Res<string> {
    return goodsRequest.post('/myself/rapidly/goods/allPagesSelectAllExport', { data })
}

/**
 * 修改库存
 */
/**
 * 修改库存
 */
export function changeBatchStock(data: UpdateStockVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateStock', { data })
}

/**
 * 预览标题修改结果
 */
/**
 * 预览修改商品名称
 */
export function reviewChangeTitle(data: PreViewUpdateItemNameParam): API.Res<PreViewItemNameVo[]> {
    return goodsRequest.post('/online/goods/preViewUpdateItemName', { data })
}

/**
 * 修改商品标题
 */
/**
 * 修改商品名称
 */
export function updateItemName(data: UpdateItemNameVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateItemName', { data })
}

/**
 * 批量下架
 */
/**
 * 修改商品状态
 */
export function updateGoodsRemoveStatus(data: UpdateGoodsStatusVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateGoodsStatus', { data })
}

/**
 * 手动更新商品资料
 */
/**
 * 手动更新店铺商品资料
 */
export function manualUpdate(data: ManualUpdateShopItemParam[]): API.Res<object> {
    return goodsRequest.post('/online/goods/manualUpdate', { data })
}

/**
 * 店铺商品操作日志
 */
/**
 * 线上商品修改操作日志明细列表
 */
export function modifyLogDetail(data: QueryLogDetailVo): API.Res<ModifyLogDetailListVo[]> {
    return goodsRequest.post('/online/goods/modifyLogDetail/list', { data })
}

/**
 * 店铺操作日志明细
 */
/**
 * 线上商品修改操作日志详情变更内容
 */
export function changedContent(params: GetModifyLogDetailContentUsingGetParams): API.Res<ModifyLogDetailContentVo> {
    return goodsRequest.get('/online/goods/modifyLogDetail/changedContent', { params })
}

/**
 * 获取自定义Excel首行标题
 */
/**
 * 获取自定义Excel首行标题
 */
export function queryCustomExcelTitle(params: QueryExcelTitleUsingGetParams): API.Res<CustomExcelResult> {
    return goodsRequest.get('/supplier/goods/queryCustomExcelTitle', { params })
}

/**
 * 获取自定义Excel新增ERP提示信息
 */
/**
 * 获取自定义Excel新增ERP提示信息
 */
export function importCustomExcelTipsInfo(data: CustomExcelImportVo): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/supplier/goods/importCustomExcelTipsInfo', { data })
}

/**
 * 异步执行自定义Excel导入
 */
/**
 * 异步执行自定义Excel导入
 */
export function asyncCustomExcelImport(data: CustomExcelImportVo): API.Res<object> {
    return goodsRequest.post('/supplier/goods/asyncCustomExcelImport', { data })
}

/**
 * 批量修改SPU分销控价
 */
/**
 * 批量修改SPU分销控价
 */
export function updateRegulatePricesBySpu(): API.Res<BatchUpdateRangePriceResultVo> {
    return goodsRequest.post('/myself/batch/goods/updateRegulatePricesBySpu')
}

/**
 * 批量修改SPU分销控价 生成id
 */
/**
 * 批量修改SPU分销控价
 */
export function updateRegulatePricesBySpuV2(data: BatchUpdateRangePriceParam): API.Res<string> {
    return goodsRequest.post('/myself/batch/goods/updateRegulatePricesBySpuV2', { data })
}

/**
 * 批量修改SPU分销控价 进度条
 */
/**
 * 获取单个商品信息
 */
export function updateRegulatePricesQueryTask(params: QueryTaskUsingGet3Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/online/goods/queryTask', { params })
}

/**
 * 批量修改SKU分销控价
 */
/**
 * 批量修改SKU分销控价
 */
export function updateRegulatePricesBySku(data: BatchUpdateRangePriceParam): API.Res<BatchUpdateRangePriceResultVo> {
    return goodsRequest.post('/myself/batch/goods/updateRegulatePricesBySku', { data })
}

/**
 * spu 商品品牌修改提示
 * @param {*} post
 */
/**
 * 修改SPU维度商品品牌提示信息
 */
export function batchModifyBrandForSpuTips(data: ModifyBrandParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/brand/modifyBrandForSpuTips', { data })
}

/**
 * spu 批量修改款维度商品品牌
 * @param {*} data
 */
/**
 * 修改SPU维度商品品牌
 */
export function batchModifyBrandForSpu(data: ModifyBrandParam): API.Res<string> {
    return goodsRequest.post('/brand/modifyBrandForSpu', { data })
}

/**
 * sku 商品品牌修改提示
 * @param {*} post
 */
/**
 * 修改SKU维度商品品牌提示信息
 */
export function batchModifyBrandForSkuTips(data: ModifyBrandParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/brand/modifyBrandForSkuTips', { data })
}

/**
 * sku 批量修改款维度商品品牌
 * @param {*} data
 */
/**
 * 修改SKU维度商品品牌
 */
export function batchModifyBrandForSku(data: ModifyBrandParam): API.Res<string> {
    return goodsRequest.post('/brand/modifyBrandForSku', { data })
}

/**
 * spu 查询更新商品品牌进度
 * @param {*} params
 */
/**
 * 获取单个商品信息
 */
export function queryUpdateBrandProcess(params: QueryTaskUsingGet3Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/online/goods/queryTask', { params })
}

/**
 *  查询供应商SKU的采购价变动数量
 * @param {*} params
 */
/**
 * 查询供应商SKU的采购价变动数量
 */
export function querySupplierSkuPurchasePriceChangeNum(): API.Res<SupplierChangePriceNum> {
    return goodsRequest.get('/mall/goods/querySupplierSkuPurchasePriceChangeNum')
}

/**
 *  查询供应商采购价变动的SKUID列表
 * @param {*} params
 */
/**
 * 查询供应商采购价变动的SKUID列表
 */
export function querySupplierPurchasePriceChangeSkuIdList(
    params: QuerySupplierPurchasePriceChangeSkuIdListUsingGetParams,
): API.Res<string[]> {
    return goodsRequest.get('/mall/goods/querySupplierPurchasePriceChangeSkuIdList', { params })
}

/**
 * 查询供应商SPU的采购价变动数量
 * @param {*} params
 */
/**
 * 查询供应商SPU的采购价变动数量
 */
export function querySupplierSpuPurchasePriceChangeNum(): API.Res<SupplierChangePriceNum> {
    return goodsRequest.get('/mall/goods/querySupplierSpuPurchasePriceChangeNum')
}

/**
 * 查询供应商采购价变动的SPUID列表
 * @param {*} params
 */
/**
 * 查询供应商采购价变动的SPUID列表
 */
export function querySupplierPurchasePriceChangeSpuIdList(
    params: QuerySupplierPurchasePriceChangeSpuIdListUsingGetParams,
): API.Res<string[]> {
    return goodsRequest.get('/mall/goods/querySupplierPurchasePriceChangeSpuIdList', { params })
}

/**
 * 查询基本商品数据统计
 * @param {*} params
 */
/**
 * 查询基本商品数据统计
 */
export function queryBasicGoodsDataStatistics(
    params: QueryBasicGoodsDataStatisticsUsingGetParams,
): API.Res<BasicDataStatistics> {
    return goodsRequest.get('/queryBasicGoodsDataStatistics', { params })
}

/**
 * 查询商品数量配置
 * @param {*} params
 */
/**
 * 查询商品数量限制配置
 */
export function queryGoodsQtyConfig(): API.Res<GoodsQtyConfigResult> {
    return goodsRequest.get('/limit/queryGoodsQtyConfig')
}

/**
 * 查询是否默认模糊查询
 * @param params
 * @returns {*}
 */
/**
 * 商品编码是否可以模糊搜索
 */
export function queryItemCodeLikeSearch(): API.Res<boolean> {
    return goodsRequest.get('/limit/itemCodeLikeSearch')
}

/**
 * 查询是否默认模糊查询
 * @param params
 * @returns {*}
 */
/**
 * 商品编码是否可以模糊搜索
 */
export function queryPartnerSpuItemCodeLikeSearch(): API.Res<boolean> {
    return goodsRequest.get('/buyer/partnerSpu/itemCodeLikeSearch')
}

/**
 * 预览商品主图修改信息
 */
/**
 * 预览商品主图修改信息
 */
export function preViewUpdateItemMainImage(data: PreViewUpdateItemMainImageParam): API.Res<PreViewItemMainImageVo[]> {
    return goodsRequest.post('/online/goods/preViewUpdateItemMainImage', { data })
}

/**
 * 修改商品主图
 */
/**
 * 修改商品主图
 */
export function updateItemMainImage(data: UpdateItemMainImageVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateItemMainImage', { data })
}

/**
 * 添加抖店SPU
 */
/**
 * 添加抖店标品
 */
export function addDySpu(data: DouYinCreateSpuParam): API.Res<string> {
    return goodsRequest.post('/shelves/douDianShelves/addDySpuV2', { data })
}

// 查询SPU规则
/**
 * 查询SPU规则
 */
export function querySpuRule(params: QuerySpuRuleUsingGetParams): API.Res<DouYinSpuRule> {
    return goodsRequest.get('/shelves/douDianShelves/querySpuRule', { params })
}

// 查询spu维度店铺资料V2
/**
 * 查询spu维度店铺资料V2
 */
export function queryShopSpuDetailsV2(data: ShopSpuQueryVoV2): API.Res<ShopSpuDetailVo[]> {
    return goodsRequest.post('/shopItemQuery/queryShopSpuDetailsV2', { data })
}

// 自营商品查询sku维度店铺资料V2
/**
 * 自营商品查询sku维度店铺资料V2
 */
export function queryShopSkuDetailsV2(data: GoodsShopSkuQueryVo): API.Res<ShopSkuDetailVo[]> {
    return goodsRequest.post('/shopItemQuery/queryShopSkuDetailsV2', { data })
}

// 分销商品查询sku维度店铺资料
/**
 * 分销商品查询sku维度店铺资料V2
 */
export function queryDrpShopSkuDetailsV2(data: DrpShopSkuQueryVo): API.Res<ShopSkuDetailVo[]> {
    return goodsRequest.post('/shopItemQuery/queryDrpShopSkuDetailsV2', { data })
}

// 基础商品查询sku维度店铺资料V2
/**
 * 基础商品查询sku维度店铺资料V2
 */
export function queryErpShopSkuDetailsV2(data: ErpShopSkuQueryVo): API.Res<ShopSkuDetailVo[]> {
    return goodsRequest.post('/shopItemQuery/queryErpShopSkuDetailsV2', { data })
}

// 查看款下商品编码是否超过1000
/**
 * 查询批量更新线上商品商品列表数量是否超过限制-款维度
 */
export function spuIsOverLimit(data: ShopSpuQueryParam): API.Res<boolean> {
    return goodsRequest.post('/shopItem/spuIsOverLimit', { data })
}

// 商品管理查询SKU信息及价格信息（按款）
/**
 * 商品管理查询SKU信息及价格信息
 */
export function queryGoodsManagePrices(data: SkuAndPriceQueryParam): API.Res<GoodsSkuAndPriceVo[]> {
    return goodsRequest.post('/checkPrice/queryGoodsManagePrices', { data })
}

// 商品管理查询SKU信息及价格信息（按sku）
/**
 * 商品管理查询SKU信息及价格信息-按SKU
 */
export function queryGoodsManagePricesForSku(data: SkuAndPriceQueryForSkuParam): API.Res<GoodsSkuAndPriceVo[]> {
    return goodsRequest.post('/checkPrice/queryGoodsManagePricesForSku', { data })
}

// 商品修改价格（20221217）
/**
 * 按成本价改价查询批量修改基本售价提示说明
 */
export function queryUpdateBasePriceByCostPriceV2(data: GoodsModifyPriceParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePriceByCostPrice', { data })
}

/**
 * 按成本价改价查询批量修改基本售价提示说明
 */
export function queryUpdateBasePriceByCostPriceForSkuV2(data: GoodsModifyPriceParamForSku): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePriceByCostPriceForSku', { data })
}

/**
 * 按采购价改价查询批量修改基本售价提示说明
 */
export function queryUpdateBasePriceByPurchaseV2(data: GoodsModifyPriceParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePriceByPurchase', { data })
}

/**
 * 按采购价改价查询批量修改sku基本售价提示说明
 */
export function queryUpdateBasePriceByPurchaseForSkuV2(data: GoodsModifyPriceParamForSku): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePriceByPurchaseForSku', { data })
}

/**
 * 查询批量修改基本售价提示说明
 */
export function queryUpdateBasePricesTaskV2(data: GoodsModifyPriceParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePricesTask', { data })
}

/**
 * 查询批量修改sku基本售价提示说明
 */
export function queryUpdateBasePricesTaskForSkuV2(data: GoodsModifyPriceParamForSku): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePricesTaskForSku', { data })
}

// 检查所有商品是否都有基准价格
/**
 * 校验选中商品是否存在来源价格
 */
export function checkPriceIsNull(data: SkuAndPriceQueryParam): API.Res<boolean> {
    return goodsRequest.post('/checkPrice/checkPriceIsNull', { data })
}

// 获取线上商品是否存在
/**
 * 获取线上商品是否存在
 */
export function onlineItemCheck(data: OnlineItemCheckVo): API.Res<OnlineItemInfoVo[]> {
    return goodsRequest.post('/supplier/goGoodsOnlineItem/onlineItemCheck', { data })
}

// 按款删除店铺商品
/**
 * 按款删除店铺商品
 */
export function deleteShopItems(data: DeleteShopItemParam): API.Res<object> {
    return goodsRequest.post('/shopManage/deleteShopItems', { data })
}

// 按款查询相应Sku
/**
 * 店铺商品管理查询款内商品编码列表
 */
export function queryShopItemSkuItemCodeList(data: ShopManageSkuItemCodeQueryVo): API.Res<string[]> {
    return goodsRequest.post('/shopManage/queryShopItemSkuItemCodeList', { data })
}

// 店铺商品管理按款查询详情
/**
 * 店铺商品管理按款查询详情
 */
export function queryShopItemDetail(data: ShopDetailParamVo): API.Res<SimpleShopSpuVo> {
    return goodsRequest.post('/shopItemDetail/queryShopItemDetail', { data })
}

// 按款查询相应Sku
/**
 * 修改商品编码
 */
export function updateItemCode(data: UpdateItemCodeVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateItemCode', { data })
}

// 校验选中店铺是否能执行当前操作
/**
 * 校验选中店铺是否能执行当前操作
 */
export function canUpdateShop(params: CanUpdateShopUsingGetParams): API.Res<CanUpdateResultVo> {
    return goodsRequest.get('/online/goods/canUpdateShop', { params })
}

// 按款查询相应Sku
/**
 * 校验修改商品状态后是否需要弹出有效商品数不满足寻合作警告(true:警告/false:不警告)
 */
export function checkValidSpuWarn(data: CheckValidSpuSatisfiedVo): API.Res<boolean> {
    return goodsRequest.post('/statistics/checkValidSpuWarn', { data })
}

// 当前商家是否满足寻合作公开有主图的商品数量
/**
 * 当前是否满足寻合作公开有主图的商品数量
 */
export function validSpuCountSatisfied(): API.Res<boolean> {
    return goodsRequest.get('/statistics/validSpuCountSatisfied')
}

// 微盟零售分配门店
/**
 * 微盟零售分配门店
 */
export function updateAssignShop(data: UpdateAssignShopVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateAssignShop', { data })
}

// 修改京东到家门店可售状态
/**
 * 修改京东到家门店可售状态
 */
export function updateStoreAvailable(data: UpdateStoreAvailableVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateStoreAvailable', { data })
}

// 修改京东到家门店可售状态
/**
 * 分页获取门店商品修改日志
 */
export function pageStoreModifyLog(data: BranchShopModifyLogParam): API.Res<BranchShopModifyLogVo[]> {
    return goodsRequest.post('/branchShopModifyLogDetail/pageStoreModifyLog', { data })
}

/**
 * 获取站点下店铺统计信息
 */
/**
 * 获取站点下店铺统计信息
 */
export function queryShopInfoTotal(data: QueryShopTotalDTO): API.Res<ShopTotalVo[]> {
    return companyRequest.post('/erpShopInfo/shop/authAndEnable/total', { data })
}

// 获取门店授权
/**
 * 获取用户店铺下的门店权限
 */
export function queryBranchShopPermission(params: GetShopBranchInfoUsingGetParams): API.Res<ShopBranchInfoVO[]> {
    return companyRequest.get('/company/permission/getShopBranchInfo', { params })
}

// 全量修改商品草稿状态
/**
 * 全量修改商品草稿状态
 */
export function modifyDraftStatusByCondition(data: UpdateAllRapidlySpuVo): API.Res<string> {
    return goodsRequest.post('/supplier/goods/modifyDraftStatusByCondition', { data })
}

// 批量已发布转草稿
/**
 * 批量已发布转草稿
 */
export function publishToDraft(data: BatchOperateSpuVo): API.Res<object> {
    return goodsRequest.post('/supplier/goods/publishToDraft', { data })
}

// 批量草稿转已发布
/**
 * 批量草稿转已发布
 */
export function draftToPublished(data: BatchOperateSpuVo): API.Res<object> {
    return goodsRequest.post('/supplier/goods/draftToPublished', { data })
}

// 查询商品草稿状态 [spu]
/**
 * 查询商品草稿状态
 */
export function queryItemDraftStatus(data: CoIdAndSpuVo): API.Res<DraftStatusResultVo[]> {
    return goodsRequest.post('/goodsQuery/queryItemDraftStatus', { data })
}

// 查询商品草稿状态 [sku]
/**
 * 查询SKU商品草稿状态(只能查询自己的商品)
 */
export function querySkuDraftStatus(data: DraftStatusSkuParamVo): API.Res<DraftStatusSkuResultVo[]> {
    return goodsRequest.post('/goodsQuery/querySkuDraftStatus', { data })
}

// 平台资料操作日志列表
/**
 * 平台资料操作日志列表
 */
export function oplogList(data: GoodsOperateLogQueryVo): API.Res<GoodsOperateLogVo[]> {
    return goodsRequest.post('/goods/oplog/list', { data })
}

// 平台资料铺货操作日志明细
/**
 * 平台资料铺货操作日志明细
 */
export function oplogShelvesLogDetail(params: ShelvesLogDetailUsingGetParams): API.Res<GylItemShelvesInfo[]> {
    return goodsRequest.get('/goods/oplog/shelvesLogDetail', { params })
}

// 平台资料铺货操作日志明细
/**
 * 平台资料导入操作日志明细
 */
export function oplogImportLogDetail(data: GoodsImportLogDetailQueryVo): API.Res<GoodsImportLogDetailVo[]> {
    return goodsRequest.post('/goods/oplog/importLogDetail', { data })
}

// 加载商品导入日志头
/**
 * 加载商品导入日志头
 */
export function oplogImportLogInfo(params: ImportLogUsingGetParams): API.Res<GoodsImportLoad> {
    return goodsRequest.get('/goods/oplog/importLog', { params })
}

// 平台资料删除操作日志明细
/**
 * 平台资料删除操作日志明细
 */
export function oplogDeleteLogDetail(data: QueryDeletedSkuParam): API.Res<DeletedSkuVo[]> {
    return goodsRequest.post('/goods/oplog/deleteLogDetail', { data })
}

/**
 * 平台资料删除操作日志明细
 */
/**
 * 商品修改日志明细
 */
export function queryGoodsUpdateLogDetailList(data: string[]): API.Res<OperateLogVo[]> {
    return goodsRequest.post('/goods/oplog/queryGoodsUpdateLogDetailList', { data })
}

// 店铺商品资料操作日志列表
/**
 * 店铺商品资料操作日志列表
 */
export function storeOplogList(data: OnlineItemOperateLogQueryVo): API.Res<ModifyLogDetailListVo[]> {
    return goodsRequest.post('/onlineItem/oplog/list', { data })
}

// 店铺商品修改操作日志详情变更内容
/**
 * 店铺商品修改操作日志详情变更内容
 */
export function storeOplogChangedContent(
    params: GetModifyLogDetailContentUsingGet1Params,
): API.Res<ModifyLogDetailContentVo> {
    return goodsRequest.get('/onlineItem/oplog/changedContent', { params })
}

// 查询商品导入列表标签(数量统计)
/**
 * 查询商品导入列表标签(数量统计)
 */
export function importLogTag(data: GoodsImportLogTagQueryVo): API.Res<QueryImportDetailTag> {
    return goodsRequest.post('/goods/oplog/importLogTag', { data })
}

// 平台资料操作类型列表
/**
 * 平台资料操作类型列表
 */
export function operateTypeList(): API.Res<LogOperateTypeVo[]> {
    return goodsRequest.get('/goods/oplog/operateTypeList')
}

// 店铺资料操作类型列表
/**
 * 平台资料操作类型列表
 */
export function storeOperateTypeList(): API.Res<LogOperateTypeVo[]> {
    return goodsRequest.get('/onlineItem/oplog/operateTypeList')
}

// 管理控价查询商品列表
/**
 * 管理控价查询商品列表
 */
export function queryBreakPriceGoodsList(params: QueryGoodsListUsingGetParams): API.Res<BreakPriceResultVo[]> {
    return goodsRequest.get('/breakPrice/queryGoodsList', { params })
}

//  查询所有控价平台
export function queryAllGylPlatform(params) {
    return companyRequest.get('/shop/queryAllGylPlatform', {
        params,
    })
}

//  更新转异常平台
export function turnAbnormalPlatform(data) {
    return goodsRequest.post('/breakPrice/turnAbnormalPlatform', {
        data,
    })
}

//  清空转异常平台-恢复为默认
export function clearTurnAbnormalPlatform(data) {
    return goodsRequest.post('/breakPrice/clearTurnAbnormalPlatform', {
        data,
    })
}

// 导出修改分销控价模板
/**
 * 导出修改分销控价模板
 */
export function exportBreakPriceTemplate(): API.Res<string> {
    return goodsRequest.get('/breakPrice/exportTemplate')
}

// 导出商品分销控价
/**
 * 导出商品分销控价
 */
export function exportRegulatePrice(data: ExportRePriceParam): API.Res<string> {
    return goodsRequest.post('/breakPrice/exportRegulatePrice', { data })
}

// 导入批量修改分销控价
/**
 * 导入批量修改分销控价
 */
export function importModifyRegulatePrice(data: ImportModifyRegulateVo): API.Res<string> {
    return goodsRequest.post('/modifyPrice/importModifyRegulatePrice', { data })
}

// 批量修改分销控价
/**
 * 批量修改分销控价
 */
export function batchModifyRegulatePrice(data: RegulatePriceModifyParam): API.Res<string> {
    return goodsRequest.post('/modifyPrice/batchModifyRegulatePrice', { data })
}

// 批量修改分销控价(sku)
/**
 * 批量修改分销控价
 */
export function batchModifyRegulatePriceSku(data: RegulatePriceModifySkuParam): API.Res<string> {
    return goodsRequest.post('/modifyPrice/batchModifyRegulatePriceSku', { data })
}

// 查询破价商品统计数据
/**
 * 查询破价商品统计数据
 */
export function queryBreakPriceSum(): API.Res<BreakPriceSumVo> {
    return goodsRequest.get('/goRpaShopItemRelation/queryBreakPriceSum')
}

// 查询破价商品
/**
 * 查询破价商品
 */
export function queryBreakPriceItem(params: QueryBreakPriceItemUsingGetParams): API.Res<RpaRelationItemVo[]> {
    return goodsRequest.get('/goRpaShopItemRelation/queryBreakPriceItem', { params })
}

// 导出破价商品
/**
 * 导出破价商品
 */
export function exportBreakPriceItem(params: ExportBreakPriceItemUsingGetParams): API.Res<string> {
    return goodsRequest.get('/goRpaShopItemRelation/exportBreakPriceItem', { params })
}

// 查询资料编码列表
/**
 * 查询资料编码列表
 */
export function queryStyleCodeList(params: QueryStyleCodeListUsingGetParams): API.Res<object[]> {
    return goodsRequest.get('/cache/queryStyleCodeList', { params })
}

// 查询标签列表
/**
 * 查询标签列表
 */
export function queryLabels(): API.Res<string[]> {
    return goodsRequest.get('/freshman/goods/queryLabels')
}

// 移除标签
/**
 * 移除标签
 */
export function removeLabels(data: BatchFreshmanLabelUpdateVo): API.Res<boolean> {
    return goodsRequest.post('/freshman/goods/removeLabels', { data })
}

// 批量更新标签
/**
 * 批量更新标签
 */
export function batchUpdateLabels(data: BatchFreshmanLabelUpdateVo): API.Res<FreshmanUpdateTipVo> {
    return goodsRequest.post('/freshman/goods/batchUpdateLabels', { data })
}

// 查询微信公众号 关注二维码
/**
 * 微信公众号 关注二维码
 */
export function officialAccountOfficialUrl(params: OfficialUrlUsingGetParams): API.Res<string> {
    return companyRequest.get('/wechat/officialAccount/officialUrl', { params })
}

// 根据线上款式编码查询商品编码
/**
 * 根据线上款式编码查询商品编码
 */
export function queryItemCodeByShopStyleCode(data: ShopManageSkuQueryVo): API.Res<string[]> {
    return goodsRequest.post('/shopManage/queryItemCodeByShopStyleCode', { data })
}

// 部分更新淘宝铺货模版
/**
 * 部分更新淘宝铺货模版
 */
export function partialUpdateTaoBaoShelvesTemplate(data: TaoBaoShelvesTemplateContent): API.Res<object> {
    return goodsRequest.post('/goods/goItemShelvesTemplate/partialUpdateTaoBaoShelvesTemplate', { data })
}

// 部分更新抖音铺货模版
/**
 * 部分更新抖音铺货模版
 */
export function partialUpdateDouYinShelvesTemplate(data: DouyinShelvesTemplateContent): API.Res<object> {
    return goodsRequest.post('/goods/goItemShelvesTemplate/partialUpdateDouYinShelvesTemplate', { data })
}

// 部分更新拼多多铺货模版
/**
 * 部分更新拼多多铺货模版
 */
export function partialUpdatePddShelvesTemplate(data: PddShelvesTemplateContent): API.Res<object> {
    return goodsRequest.post('/goods/goItemShelvesTemplate/partialUpdatePddShelvesTemplate', { data })
}

// 部分更新快手铺货模版
/**
 * 部分更新快手铺货模版
 */
export function partialUpdateKuaiShouShelvesTemplate(data: KuaishouShelvesTemplateContent): API.Res<object> {
    return goodsRequest.post('/goods/goItemShelvesTemplate/partialUpdateKuaiShouShelvesTemplate', { data })
}

// 部分更新京东铺货模版
/**
 * 部分更新京东铺货模版
 */
export function partialUpdateJdShelvesTemplate(data: JdShelvesTemplateContent): API.Res<object> {
    return goodsRequest.post('/goods/goItemShelvesTemplate/partialUpdateJdShelvesTemplate', { data })
}

// 查询第一个线上店铺商品
/**
 * 查询第一个线上店铺商品
 */
export function queryFirstOnlineShopGoods(
    params: QueryFirstOnlineShopGoodsUsingGetParams,
): API.Res<FirstOnlineShopGoodsResult> {
    return goodsRequest.get('/supplier/goGoodsOnlineItem/queryFirstOnlineShopGoods', { params })
}

// 批量修改限制分销铺货平台
/**
 * 批量修改限制分销铺货平台
 */
export function batchUpdateLimitShelvesPlatform(data: UpdateLimitShelvesPlatformParam): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateLimitShelvesPlatform', { data })
}

// 批量修改限制分销铺货平台-平台资料-全部页
/**
 * 批量修改限制分销铺货平台(平台资料-全部页)
 */
export function batchUpdateLimitShelvesPlatformForCondition(data: UpdateLimitShelvesPlatformParamAll): API.Res<string> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateLimitShelvesPlatformForCondition', { data })
}

// 批量修改限制分销铺货平台-我的小站-全部页
/**
 * 批量修改限制分销铺货平台(我的小站-全部页)
 */
export function batchUpdateLimitShelvesPlatformMallForCondition(
    data: UpdateLimitShelvesPlatformParamMallAll,
): API.Res<string> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateLimitShelvesPlatformMallForCondition', { data })
}

// 批量修改分销控价拦截上架的状态
/**
 * 批量修改分销控价拦截上架的状态
 */
export function batchUpdateRegulatePriceIntercept(data: BatchUpdateRegulatePriceInterceptParam): API.Res<object> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateRegulatePriceIntercept', { data })
}

// 批量修改分销控价拦截上架的状态-全部页
/**
 * 批量修改分销控价拦截上架的状态(平台资料-全部页)
 */
export function batchUpdateRegulatePriceInterceptForCondition(
    data: BatchAllUpdateRegulatePriceInterceptParam,
): API.Res<string> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateRegulatePriceInterceptForCondition', { data })
}

// 批量修改分销控价拦截上架的状态(我的小站-全部页)
/**
 * 批量修改分销控价拦截上架的状态(我的小站-全部页)
 */
export function batchUpdateRegulatePriceInterceptForMallCondition(
    data: BatchAllUpdateRegulatePriceInterceptParam1,
): API.Res<string> {
    return goodsRequest.post('/myself/batch/goods/batchUpdateRegulatePriceInterceptForMallCondition', { data })
}

// 按SKU批量下架供应商已下架分销商品【按SKU】
/**
 * 批量下架分销商品
 */
export function batchForShelved(data: BatchForShelvedParam): API.Res<string> {
    return goodsRequest.post('/goChannelPartnerSku/batchForShelved', { data })
}

// 按SKU批量下架供应商已下架分销商品【按款】
/**
 * 按款批量下架供应商已下架分销商品
 */
export function batchForShelvedSupplierForShelvedForSpu(): API.Res<string> {
    return goodsRequest.post('/buyer/partnerSpu/batchForShelvedSupplierForShelvedForSpu')
}

// 店铺商品资料ERP操作日志列表
/**
 * 店铺商品资料ERP操作日志列表
 */
export function queryErpLogList(data: QueryErpLogParam): API.Res<ShopItemErpLog[]> {
    return goodsRequest.post('/shopSkuManage/queryErpLogList', { data })
}

// 查询商品列表异步信息
/**
 * 查询商品列表异步信息
 */
export function querySpuListAsyncInfo(data: string[]): API.Res<SpuListAsyncInfo[]> {
    return goodsRequest.post('/goods/querySpuListAsyncInfo', { data })
}

// 异步加载主图信息
/**
 * 异步加载主图信息
 */
export function asyncLoadMainPic(data: SupplierSyncShopItemVo[]): API.Res<AsyncLoadMainPicVo[]> {
    return goodsRequest.post('/online/goods/asyncLoadMainPic', { data })
}

// 替换为供应商主图
/**
 * 替换为供应商主图
 */
export function replaceWithSupplierItemMainImage(data: ReplaceOnlineMainImageVo): API.Res<string> {
    return goodsRequest.post('/online/goods/replaceWithSupplierItemMainImage', { data })
}

/**
 * 查询spu时效库存列表
 */
/**
 * 查询spu时效库存列表
 */
export function querySpuTimeSaleStock(data: string[]): API.Res<SpuTimeSaleStockVo[]> {
    return goodsRequest.post('/goods/stock/querySpuTimeSaleStock', { data })
}

/**
 * 查询sku时效库存列表
 */
export function querySkuTimeSaleStock(data: string[]): API.Res<TimeSaleStock[]> {
    return goodsRequest.post('/goods/stock/querySkuTimeSaleStock', { data })
}
/**
 * 获取商品将超限弹窗
 */
export function getGoodsQtyOverLimitAlarm(params) {
    return goodsRequest.get('/limit/getGoodsQtyOverLimitAlarm', {
        params,
    })
}

/**
 * 更新商品将超限弹窗确认时间
 */
export function updateGoodsQtyOverLimitAlarmTimeApi(data) {
    return goodsRequest.post('/limit/updateGoodsQtyOverLimitAlarmTime', {
        data,
    })
}

/**
 * 查询平台禁用的关键词
 */
export function queryPlatformBanKeywords(params) {
    return goodsRequest.get('/switchConfig/queryPlatformBanKeywords', {
        params,
    })
}

/**
 * 根据销量全部页删除商品
 */
export function allDeleteBySaleNumUsingPOST(data: AllRemoveAndProhibitSellParam): API.Res<string> {
    return goodsRequest.post('/supplier/goods/allDeleteBySaleNum', { data })
}

/**
 * 查询现有的配置的分销商
 */
export function queryLimitPlatformChannelUsingPOST(
    data: QueryLimitPlatformChannelParam,
): API.Res<QueryLimitPlatformChannelResp> {
    return goodsRequest.post('/myself/batch/goods/queryLimitPlatformChannel', { data })
}

/**
 * 分销商品操作日志列表
 */
export function drpGoodsList(data: GoodsOperateLogQueryVo): API.Res<DrpOperateLogVo[]> {
    return goodsRequest.post('/goods/oplog/drpGoodsList', { data })
}

/**
 * 分销商品操作日志详情
 */
export function drpGoodsDetail(data: string[]): API.Res<GoDrpGoodsOperateLogDetail[]> {
    return goodsRequest.post('/goods/oplog/drpGoodsDetail', { data })
}

/**
 * 平台资料操作类型列表
 */
export function drpOperateTypeList(): API.Res<LogOperateTypeVo[]> {
    return goodsRequest.get('/goods/oplog/drpOperateTypeList')
}
